module.exports = __webpack_public_path__ + "static/media/iconmonstr-download-6.71a1d2de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/iconmonstr-download-6.svg
// module id = 719
// module chunks = 0